import type { Ad, Campaign } from '../../demo/types'

export const HEALTH_WEEK_BASELINE = 76

export interface CampaignAdSummary {
  impressions: number
  clicks: number
}

export function selectRecentCampaigns(campaigns: Campaign[]): Campaign[] {
  return campaigns
    .filter((campaign) => campaign.spendMonth > 0 && campaign.attentionReason === null)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    .slice(0, 3)
}

export function summarizeCampaignAds(ads: Ad[], campaignId: string): CampaignAdSummary {
  return ads.reduce<CampaignAdSummary>((summary, ad) => {
    if (ad.campaignId !== campaignId) return summary
    return {
      impressions: summary.impressions + ad.impressions,
      clicks: summary.clicks + ad.clicks,
    }
  }, { impressions: 0, clicks: 0 })
}

export function toFixed1HalfEven(value: number): string {
  const scaled = value * 10
  const floor = Math.floor(scaled)
  const diff = scaled - floor
  const rounded = diff > 0.5 ? floor + 1 : diff < 0.5 ? floor : (floor % 2 === 0 ? floor : floor + 1)
  return (rounded / 10).toFixed(1)
}

export function healthStatus(score: number): { word: string; tone: 'green' | 'orange' | 'red' } {
  if (score >= 90) return { word: '优秀', tone: 'green' }
  if (score >= 70) return { word: '良好', tone: 'green' }
  if (score >= 50) return { word: '需关注', tone: 'orange' }
  return { word: '有风险', tone: 'red' }
}

export function healthWeekDelta(score: number): number {
  return score - HEALTH_WEEK_BASELINE
}

export function formatUpliftPercent(delta: number): string {
  const percent = Math.round(Math.abs(delta) * 100)
  if (delta > 0) return `+${percent}%`
  if (delta < 0) return `−${percent}%`
  return '0%'
}
